import React, { useState, useEffect } from "react";
import Tunes from "../tunes/Tunes";
import axiosInstance from "../../api/base/axios";
import { useDispatch } from "react-redux";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { subscriptionDay } from "../../redux/subscriptionSlice";
import { Box, Container } from "@mui/material";
import { LineChart } from "@mui/x-charts";
import PageLoader from "../../components/PageLoader";
import dayjs from "dayjs";
import {
  Chart as ChartJS,
  TimeScale,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import "chartjs-adapter-dayjs-4";
import { Line } from "react-chartjs-2";

ChartJS.register(
  TimeScale,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

interface ITunes {
  date: string;
  count: string;
}

const Dashboard = () => {
  const dispatch = useAppDispatch();
  const selector = useAppSelector((state) => state.subscriptions);

  const [loading, setLoading] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [tunes, setTunes] = useState<ITunes[]>(selector.subscriptionDay);

  const fetchTunes = async (): Promise<any> => {
    try {
      setLoading(true);
      await axiosInstance.get("/skiza/report/date").then((res) => {
        setTunes(res.data.subscriptions);
        setLoading(false);
        dispatch(subscriptionDay(res.data.subscriptions));
      });
    } catch (error) {
      setLoading(false);
      console.log("err", error);
    }
  };

  useEffect(() => {
    if (selector.subscriptionDay.length <= 0) {
      fetchTunes();
    }
  }, []);

  const data = {
    labels: tunes && tunes.map((el) => el.date),
    datasets: [
      {
        label: "Subscriptions per day",
        data: tunes && tunes.map((el) => parseInt(el.count)),
        borderColor: "rgb(75, 192, 192)",
        borderWidth: 2,
        fill: false,
      },
    ],
  };

  // Customize the options for the chart
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top" as const,
      },
      title: {
        display: true,
        text: "Subscriptions per day",
      },
    },
    scales: {
      // x: {
      //   type: "time" as any,
      //   time: {
      //     unit: "day",
      //     stepSize: 2, // Set the step size to 2 days (interval between labels)
      //     tooltipFormat: "YYYY-MM-DD",
      //   },
      // },
      y: {
        title: {
          display: true,
          text: "Count",
        },
      },
    },
  };

  return (
    <Container maxWidth="xl" sx={{ width: "100%", height: "100vh" }}>
      {/* <Tunes /> */}
      {tunes && tunes.length > 0 && <Line data={data} options={options} />}
    </Container>
  );
};

export default Dashboard;
